/**
 * Test IDs for QA automation.
 */
export const testIds = {
  downloadSendInvoiceButtonsGenerateInvoice: "download-send-invoice-buttons-generate-invoice",
  downloadSendInvoiceButtonsDownload: "download-send-invoice-buttons-download",
  downloadSendInvoiceButtonsPrintInvoice: "download-send-invoice-buttons-print-invoice",
  downloadSendInvoiceButtonsSendInvoice: "download-send-invoice-buttons-send-invoice",
  downloadSendInvoiceButtonsOpenMarkAsPaid: "download-send-invoice-buttons-open-mark-as-paid",
  downloadSendInvoiceButtonsInvoiceNumber: "download-send-invoice-buttons-invoice-number",
  downloadSendInvoiceButtonsConfirmGenerateInvoice: "download-send-invoice-buttons-confirm-generate-invoice",
  downloadSendInvoiceButtonsConfirmMarkAsPaid: "download-send-invoice-buttons-confirm-mark-as-paid",
} as const;
